<template>
  <div>
    <div class="container" style="font-family: SourceHanSansCN-Regular;" v-if="isMobile">
      <div class="live-video-title">
        <!--视频展示区域-->
        <div
            style="z-index: 999"
            class="live-video-title-video"
            v-if="contentTop.cover">
          <videoPlay style="width: 100%" v-if="fileId"/>
          <img
              v-else
              style="width: 100%;height: 200px;border: 1px solid #f5f5f5"
              :src="contentTop.cover[0]" alt="">
        </div>
        <div class="live-video-title-title">
          <div class="title" style="font-weight: 800;font-size: 18px;padding-left: 10px">{{contentTop.title}}</div>
          <div class="lookPer" style="text-align: right;padding-right: 15px"><span><van-icon name="eye-o"  style="margin-right: 2px"/></span>{{contentTop.browseCount}}</div>
        </div>
      </div>
      <!--   id="tabsSty"   line-width="80"   -->
      <div class="video-include">
        <van-tabs
            swipeable
            class="tabs"
            color="#45a5e6"
            v-model="active"
            @click="onTabsClick"
            title-active-color="#45a5e6">
          <van-tab>
            <span  class="font-sty" slot="title">讲者</span>
            <div style="background-color: #FFFFFF;overflow-y: scroll;height: 300px;">
              <div class="lecturer">
                <div class="lecturer-div" v-if="contentTop.vodVideoLecturer">
                  <div class="lecturer-div-img">
                    <img :src="contentTop.vodVideoLecturer.headimg" alt="">
                  </div>
                  <div class="include">
                    <div>{{contentTop.vodVideoLecturer.name}}</div>
                    <div class="hos">{{contentTop.vodVideoLecturer.hospital}}</div>
                  </div>
                </div>
              </div>
            </div>
          </van-tab>
          <van-tab>
            <span  class="font-sty" slot="title">介绍</span>
            <div style="background-color: #FFFFFF;overflow-y: scroll;height: 400px;">
              <div class="include-lecturer" ref="includeRef" id="includeId">
                <div v-if="contentTop.intro" class="include-lecturer-content" v-html="contentTop.intro">
                </div>
                <div
                    v-if="!contentTop.intro"
                    style="width: 100%;height: 200px;line-height: 200px;text-align: center;color: #9B9B9B">
                  暂无介绍...
                </div>
              </div>
            </div>
          </van-tab>
          <van-tab>
            <span  class="font-sty" slot="title">评论</span>
            <div style="background-color: #FFFFFF;overflow-y: scroll;height: 400px;">
              <div class="include-comment" ref="commentRef" id="commentId" >

                <div class="comment-content" v-if="contentTop.comments">
                  <div class="comment-content-list"
                       v-for="(commList,index) in contentTop.comments" :key="index">
                    <div style="display:flex;margin-top: 15px">
                      <div >
                        <img
                            style="width: 50px;height: 50px;border-radius: 25px"
                            :src="commList.headimg" alt="">
                      </div>
                      <div style="margin-left: 10px;margin-top: 5px">
                        <div>{{commList.name}}</div>
                        <div style="color: #9B9B9B;font-size: 12px;margin-top:5px;display: flex;">
                          <div>{{commList.hospitalName}}</div>
                          <div style="margin-left: 30px">{{commList.createdTime}}</div>
                        </div>
                      </div>
                    </div>
                    <div style="margin-left: 60px;font-size: 14px">
                      {{commList.content}}
                    </div>
                    <!--二级回复-->
                    <div v-if="commList.commentTwos !== undefined && commList.commentTwos !== '' && commList.commentTwos !== null">
                      <div style="margin-left: 10%" v-if="commList.commentTwos">
                        <div v-for="(childComm,index) in commList.commentTwos" :key="index">
                          <div style="display:flex;margin-top: 5px">
                            <div >
                              <img
                                  style="width: 50px;height: 50px;border-radius: 25px"
                                  :src="childComm.headimg" alt="">
                            </div>
                            <div style="margin-left: 10px;margin-top: 5px">
                              <div>{{childComm.name}}</div>
                              <div style="color: #9B9B9B;font-size: 12px;margin-top:5px;display: flex;">
                                <div style="width: 55%;display: -webkit-box;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 1;
                  word-break: break-all;">{{childComm.hospitalName}}</div>
                                <div style="margin-left: 30px">{{childComm.createdTime}}</div>
                              </div>
                            </div>
                          </div>
                          <div style="margin-left: 60px;font-size: 14px">
                            {{childComm.content}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else style="width: 100%;height: 200px;line-height: 200px;text-align: center;color: #9B9B9B">
                  暂无评论...
                </div>
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
      <div style="position: absolute;bottom: 200px;">
        <openAPP/>
      </div>
    </div>
  </div>
</template>

<script>

import {getLiveShareList} from "../../service/subscribeShare_api";

export default {
  components: {
    openAPP:()=>import('../../components/share_foot'),
    videoPlay:()=>import('../../utils/videos')
  },
  data(){
    return{
      isCommentShow:true,
      isMobile:false,
      fileId:'',
      lecturerHeight:0,
      includeHeight:0,
      commentHeight:0,
      headImg:require('../../assets/image/img.png'),
      commentImg:require('../../assets/image/zan1.png'),
      commentImg2:require('../../assets/image/zan2.png'),
      message:'',
      active:0,
      contentTop:{},
      listId:'',
      menuList: ['讲师', '介绍', '评论'],
    }
  },
  // async created() {
  //   this.listId = this.$route.query.id
  //   await this.getList()
  // },
  async mounted() {
    this.listId = this.$route.query.id;
    this.fileId = this.$route.query.fileId;
    this.checkDevice();
    // await this.getList();
    // await this.getHeights()
  },
  methods:{
    checkDevice() { // //判断当前设备是pc端还是移动端
      const userAgent = navigator.userAgent.toLowerCase();
      let isMobile = /mobile|tablet|ip(ad|hone|od)|android/i.test(userAgent);
      if(!isMobile){ //当前设备是pc端，且isOpenPc为1，打开电脑端
        this.isMobile = false;
        //pc端跳转到官网点播详情界面
        window.open('https://yunicu.com/detailsDemand?id='+this.listId+'&login=true',"_self");
      }else {
        this.isMobile = true;
        //手机端
        this.getList();
      }
    },
    onTabsClick(){

    },
    //获取列表数据
    //获取页面内容
    async getList() {
      const response = await getLiveShareList(this.listId)
      if(response.code === 0){
        this.contentTop = response.data
        // let comentLenght = response.data.comments.length
        // if(comentLenght === 0){
        //
        // }
      }
    },
    onClickLeft(){
      history.go(-1)
    },

  }
}
</script>

<style lang="scss">
::-webkit-scrollbar {
  width: 0;
}
::-webkit-scrollbar-track {
  background-color: #edeff2;
}
  .live-video-title{
    width: 100%;
    border-bottom: 5px solid #EEEFF1;
    position: relative;
    top: 0;
    z-index: 999999;
    .live-video-title-video{
      position: absolute;
      //position: fixed;
      top: 0;
      width: 100%;
      height: 200px;
      background-color: #f5f5f5;
    }
    .live-video-title-title{
      width: 100%;
      height: 75px;
      //position: fixed;
      position: absolute;
      top: 200px;
      border-bottom: 3px solid #f5f5f5;
      .title{
        margin: 6px;
        display: -webkit-box;
        text-overflow: ellipsis;
        overflow: hidden;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        word-break: break-all;
      }
      .lookPer{
        margin-left: 10px;
        margin-bottom: 10px;
        font-size: 14px;
        color: #9B9B9B;;
      }
    }
  }
  .video-include{
    width: 100%;
    //position: fixed;
    position: absolute;
    top: 270px;
    .tabs{
      width: 100%;
      margin: auto;
      z-index: 999;
    }
    .font-sty{
      font-size: 16px;
    }
  }
  .lecturer{
    .lecturer-div{
      height: 75px;
      border-radius: 5px;
      background-color: #EEEFF1;
      margin:17px;
      display: flex;
      .lecturer-div-img{
        padding-top: 12px;
        margin-left: 20px;
        img{
          height: 50px;
          width: 50px;
          border-radius: 50px;;
        }
      }
      .include{
        margin-left: 10px;margin-top: 15px;
        .hos{
          color: #9B9B9B;
          font-size: 12px;
          margin-top: 5px;
        }
      }
    }
  }


  .include-lecturer {
    min-height: 200px;
    .include-lecturer-include{
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid #EEEFF1;
      width: 90%;
      margin: auto;
      margin-bottom: 15px;
    }
    .include-lecturer-content{
      width: 90%;
      margin: auto;
      margin-bottom: 15px;
    }
  }
  .include-comment{
    width: 90%;
    margin: auto;
    .comment{
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid #EEEFF1;
      .comment-content-list{
        min-height: 80px;
        width: 100%;
      }
    }
  }
  .goods-video {
      height: 100%;
      .video-js {
        width: 100%;
        height: 100%;
      }

      .vjs-control-bar {
        bottom:1px;
      }

      .vjs-big-play-button {
        border-radius: 50%;
        width: 40px;
        height: 40px;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        margin: 0;
        line-height: normal;

        .vjs-icon-placeholder {
          &:before {
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: auto;
            height: auto;
          }
        }
      }

      .vjs-control-bar {

        // opacity: 1 !important;
        .vjs-play-control,
        .vjs-fullscreen-control {
          .vjs-icon-placeholder {
            &:before {
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: auto;
              height: auto;
              font-size: 25px;
            }
          }
        }

        .vjs-volume-panel,
        .vjs-picture-in-picture-control {
          display: none;
        }
      }
    }
</style>
